import { SiMongodb } from 'react-icons/si'

export const MongoTech = () => {
    return (
        <div>
        <SiMongodb />
        <h4>Mongo</h4>
        </div>
    )
}